export const portuguese = {
  feedback: {
    "title": "Enviar feedback",
    "category": "Categoria",
    "suggestion": "Sugestão",
    "problem": "Problema",
    "other": "Outro",
    "message": "O seu feedback",
    "placeholder": "O que melhoraria ou o que não funcionou?",
    "email": "Email para resposta (opcional)",
    "send": "Enviar feedback",
    "sending": "A enviar…",
    "success": "Obrigado — recebemos o seu feedback.",
    "error": "Não foi possível enviar. O texto foi guardado; tente novamente.",
    "invalid": "Introduza 10–3.000 caracteres e um email válido, se indicado.",
    "signIn": "Inicie sessão para enviar feedback",
    "inbox": "Feedback dos utilizadores",
    "empty": "Ainda não há feedback.",
    "reviewed": "Lido",
    "markReviewed": "Marcar como lido",
    "refresh": "Atualizar",
    "new": "Novo"
},
  menu: {
    signOut: "Terminar sessão",
    signIn: "Iniciar sessão / Registar",
    talkToUs: "Fala connosco",
    language: "Idioma",
    deleteAccount: "Eliminar conta",
    accountSettings: "Configurações da conta",
  },
  theme: {
    light: "Claro",
    dark: "Escuro",
  },
  landing: {
    heroKicker: "Para cidadãos e municípios de todo o mundo",
    heroSub: "Entregamos a tua voz à câmara municipal — em qualquer parte do mundo.",
    municipalityLogin: "Acesso municípios",
    pecCardTitle: "Cada denúncia chega a municípios de todo o mundo",
    pecBadge: "Email",
    pecCardBody: "De qualquer cidade, em qualquer país. Os municípios parceiros recebem as denúncias diretamente; quando um município ainda não é parceiro, enviamos mesma assim cada denúncia às autoridades locais por email, para que nenhum problema passe despercebido.",
    pecTitle: "Cada denúncia conta, mesmo sem parceria",
    pecBody: "Se o teu município ainda não é parceiro da ShapeIt, enviamos mesma assim cada denúncia às autoridades locais por email, para que nenhum problema passe despercebido.",
    pecHighlight: "Enviamos as denúncias aos municípios por email",
    ctaSub: "Junta-te a cidadãos e municípios de todo o mundo para fazer a diferença, uma denúncia de cada vez.",
  },
  mapHeader: {
    appName: "Shapeit",
    login: "Iniciar sessão / Registar",
    searchPlaceholder: "Procura locais ou clica em qualquer ponto do mapa para reportar um problema",
    clearSearch: "Limpar pesquisa",
  },
  mapLegend: {
    title: "Legenda Shapeit",
    buttonLabel: "Legenda",
    dirty: "Sujo",
    unsafe: "Inseguro",
    needsFix: "Precisa de reparação",
  },
  dialog: {
    selectLanguage: "Seleciona o teu idioma preferido",
    chooseLanguage: "Escolhe um idioma para a interface da aplicação.",
    confirm: "Confirmar",
    welcome: {
      title: "Bem-vindo!",
      message: "O Shapeit está aqui para te dar poder, queremos que sejas capaz de moldar a tua cidade e transformá-la num lugar melhor. Sempre que detetares um problema, podes reportá-lo e podes também gostar das denúncias de outros utilizadores para lhes dar maior visibilidade. Da nossa parte, vamos assegurar-nos de manter as autoridades municipais atualizadas sobre os problemas mais urgentes.",
      message2: "O Shapeit está a trabalhar para estabelecer parcerias com municípios em todo o mundo. Mesmo que a tua cidade ainda não seja parceira, enviamos cada denúncia às autoridades locais por email, para que nenhum problema passe despercebido. Cada denúncia ajuda a construir uma base de dados atualizada dos problemas urbanos da tua região: quantas mais recolhermos, mais forte será a nossa voz quando nos dirigirmos às autoridades locais. Agora vai e torna a tua cidade num lugar melhor!",
      next: "Seguinte",
      button: "Vamos começar!"
    }
  },
  reports: {
    overview: "Vista geral das denúncias",
    trending: "Em destaque",
    myReports: "As minhas denúncias",
    yourReports: "As tuas denúncias",
    recentReports: "Denúncias Recentes",
    by: "por",
    anonymous: "Anónimo",
  },
  usernameSetup: {
    title: "Escolha o seu nome de utilizador",
    description: "Escolha um nome público mostrado nas suas denúncias. Pode alterá-lo nas definições da conta.",
    placeholder: "O seu nome de utilizador",
    save: "Guardar",
    saving: "A guardar...",
    skip: "Mais tarde",
    tooShort: "O nome de utilizador deve ter pelo menos 2 caracteres",
    noEmail: "O nome de utilizador não pode conter @",
    success: "Nome de utilizador guardado",
    error: "Não foi possível guardar o nome de utilizador",
  },
  reportForm: {
    postAnonymously: "Publicar anonimamente",
    postAnonymouslyHint: "O seu nome não será mostrado nesta denúncia.",
    postingAs: "A publicar como",
    title: "Enviar uma denúncia",
    description: "Descrição",
    uploadPhoto: "Carregar fotografia",
    takePhoto: "Tirar fotografia",
    changePhoto: "Alterar fotografia",
    preview: "Pré-visualizar",
    submit: "Enviar denúncia",
    submitting: "A enviar...",
    loginRequired: "Tens de iniciar sessão para enviar uma denúncia",
    uploadFailed: "Falha ao carregar a denúncia",
    photoUploadFailed: "Não foi possível enviar a fotografia. A tua denúncia continua aqui.",
    sendWithoutPhoto: "Enviar sem fotografia",
    selectIssue: "Por favor, seleciona um tipo de problema",
    selectIssueType: "Seleciona um tipo de problema",
    moderationWarning: "As denúncias são moderadas automaticamente. Conteúdo ofensivo, spam ou inadequado será rejeitado.",
    rejectedContent: "A tua denúncia contém conteúdo inadequado e não pode ser publicada",
    rateLimitExceeded: "Atingiste o limite de 5 denúncias por hora. Tenta novamente mais tarde.",
    characterLimit: "A descrição não pode exceder 500 caracteres",
    appealLink: "Enviar recurso por e-mail",
    offensiveContent: "A tua mensagem contém linguagem inadequada",
    validatingImage: "A validar imagem...",
        aiAnalyzing: "IA está analisando...",
    duplicateWarning: "Já existe um relatório semelhante por perto. Considere votar nele em vez de criar um duplicado.",
    aiSuggestions: "Sugestões de IA",
    suggestedTitle: "Título sugerido:",
    priority: "Prioridade:",
    inappropriateImage: "A imagem contém conteúdo impróprio e não pode ser utilizada",
    notRelevantImage: "A foto não parece mostrar um problema urbano. Carregue uma foto do problema que deseja reportar.",
  },
  confirmReport: {
    question: "Queres criar uma denúncia aqui?",
    yes: "Sim",
    no: "Não"
  },
  locationPrompt: "Clica no local desejado para reportar um problema",
  reportHere: "Reportar aqui",
  deleteAccount: {
    title: "Eliminar conta",
    warning: "Esta ação é irreversível!",
    description: "Todos os teus dados serão permanentemente eliminados, incluindo:",
    items: {
      reports: "Todas as tuas denúncias",
      photos: "Todas as fotografias enviadas",
      accountData: "As informações da tua conta"
    },
    confirmLabel: "Escreve DELETE para confirmar",
    confirmPlaceholder: "DELETE",
    cancel: "Cancelar",
    deleteButton: "Eliminar a minha conta",
    deleting: "A eliminar...",
    success: "Conta eliminada com sucesso",
    error: "Falha ao eliminar a conta"
  },
  gamification: {
    totalReports: "Total de relatos",
    congratulations: "Parabéns!",
    pointsEarned: "Pontos ganhos",
    totalPoints: "Pontos totais",
    currentLevel: "Nível atual",
    levelUp: "Subiste de nível!",
    nextLevel: "Próximo nível",
    progress: "Progresso",
    thankYou: "Obrigado por tornares a cidade um lugar melhor!",
    keepGoing: "Continua a denunciar para alcançares o próximo nível!",
    continue: "Continuar",
    levels: {
      beginner: "Principiante",
      active_citizen: "Cidadão Ativo",
      urban_observer: "Observador Urbano",
      city_guardian: "Guardião da Cidade",
      civic_champion: "Campeão Cívico",
      urban_hero: "Herói Urbano"
    },
    messages: {
      beginner: "Bem-vindo à comunidade!",
      active_citizen: "Estás a fazer a diferença!",
      urban_observer: "Os teus olhos tornam a cidade melhor!",
      city_guardian: "És um verdadeiro guardião!",
      civic_champion: "Campeão do dever cívico!",
      urban_hero: "És um herói urbano!"
    }
  },
  onboarding: {
    step1: {
      title: "Bem-vindo ao Mapa!",
      description: "Aqui podes ver todas as denúncias da tua comunidade. Vamos aprender como utilizá-lo!"
    },
    step2: {
      title: "Criar uma denúncia",
      description: "Procura uma localização ou clica no mapa para criar uma nova denúncia sobre um problema na tua área."
    },
    step3: {
      title: "Tipos de denúncia",
      description: "Cores diferentes representam diferentes tipos de problemas. Clica nos marcadores para ver detalhes e votar nas denúncias que te interessam!"
    },
    step4: {
      title: "O teu perfil e gamificação",
      description: "Ganha pontos ao criar denúncias e ao ajudar a tua comunidade! Acompanha o teu nível e progresso aqui."
    },
    step5: {
      title: "Estás pronto!",
      description: "Começa a melhorar a tua comunidade reportando problemas e interagindo com outras denúncias. Cada contribuição conta!"
    },
    previous: "Anterior",
    next: "Avançar"
  },
    accountSettings: {
    title: "Configurações da conta",
    openSettings: "Configurações da conta",
    changeEmail: "Alterar email",
    newEmailLabel: "Novo endereço de email",
    newEmailPlaceholder: "novo@email.com",
    changePassword: "Alterar palavra-passe",
    newPasswordLabel: "Nova palavra-passe",
    newPasswordPlaceholder: "Pelo menos 6 caracteres",
    passwordTooShort: "A palavra-passe deve ter pelo menos 6 caracteres",
    passwordSuccess: "Palavra-passe atualizada com sucesso",
    changeUsername: "Alterar nome de utilizador",
    newUsernameLabel: "Novo nome de utilizador",
    newUsernamePlaceholder: "O teu nome de utilizador",
    usernameTooShort: "O nome de utilizador deve ter pelo menos 2 caracteres",
    usernameSuccess: "Nome de utilizador atualizado com sucesso",
    deleteAccountTitle: "Eliminar conta",
    deleteAccountDescription: "Elimina permanentemente a tua conta e todos os dados relacionados. Esta ação não pode ser desfeita.",
    deleteAccountButton: "Eliminar conta",
    save: "Guardar",
    saving: "A guardar...",
    submit: "Enviar email de confirmação",
    submitting: "A enviar...",
    invalidEmail: "Email inválido",
    error: "Erro",
    updateFailed: "Não foi possível atualizar",
    successTitle: "Email de verificação enviado",
    successDescription: "Enviámos um email de confirmação para {email}. Verifica a tua caixa de entrada para confirmar a alteração.",
    showPassword: "Mostrar senha",
    hidePassword: "Ocultar senha",
  },
  push: {
    title: "Notificações push",
    subtitle: "Gere as notificações que recebe no seu dispositivo",
    enable: "Ativar notificações push",
    denied: "Permissão negada. Ative as notificações nas definições do dispositivo.",
    registered: "Dispositivo registado",
    requestPermission: "Pedir permissão para receber notificações",
    resolved: "Denúncia resolvida",
    resolvedDesc: "Quando uma das suas denúncias é resolvida",
    upvotes: "Votos recebidos",
    upvotesDesc: "Quando alguém vota nas suas denúncias",
    achievements: "Conquistas desbloqueadas",
    achievementsDesc: "Quando desbloqueia uma nova conquista",
    newReports: "Novas denúncias",
    newReportsDesc: "Quando são criadas novas denúncias",
    updated: "Preferências atualizadas",
    updateError: "Não foi possível atualizar as preferências",
    mobileOnly: "As notificações push são enviadas na aplicação móvel",
  },
  referral: {
    inviteTitle: "Convide amigos e ganhe pontos!",
    inviteSubtitle: "Crie o seu código de convite e ganhe 50 pontos por cada amigo que se registar.",
    createCode: "Criar código de convite",
    yourCode: "O seu código de convite",
    copy: "Copiar",
    codeCopied: "Código copiado para a área de transferência!",
    linkCopied: "Ligação de convite copiada!",
    directLink: "Ligação direta",
    stats: "Estatísticas de convites",
    completed: "Concluídos",
    pending: "Pendentes",
    total: "Total",
    ambassadorProgress: "Progresso de Embaixador",
    ambassadorUnlocked: "Desbloqueou o crachá de Embaixador!",
    shareText: "Junte-se ao ShapeIt e ajude a melhorar a sua cidade! Use o meu código {code} para receber 50 pontos bónus 🎁",
    shareTitle: "Convite ShapeIt",
  },
  misc: {
    mapLoadFailed: "Não foi possível carregar o mapa",
    mapKeyError: "Não foi possível carregar a chave API do Google Maps",
    mapKeyMissing: "Chave API do Google Maps não configurada",
    mapsLoadError: "Não foi possível carregar o Google Maps",
    onlyImages: "Apenas imagens JPEG, PNG e WebP são permitidas",
    imageTooLarge: "A imagem deve ter menos de 5MB",
    photoFailed: "Não foi possível tirar a foto",
    current: "Atual",
    progress: "Progresso",
  },
  common: {
    share: "Partilhar",
    shareTitle: "Partilhar esta denúncia",
    copyLink: "Copiar ligação",
    linkCopied: "Ligação copiada para a área de transferência!",
    copyFailed: "Não foi possível copiar a ligação",
    loading: "A carregar...",
    close: "Fechar",
    delete: "Eliminar",
    cancel: "Cancelar",
    retry: "Tentar novamente",
    login: "Iniciar sessão",
    register: "Registar",
    email: "Email",
    password: "Palavra-passe",
    username: "Nome de utilizador",
    anonymous: "Anónimo",
    notYourReport: "Não é a tua denúncia",
    loginToDelete: "Inicia sessão para eliminar",
    upvotes: "Votos",
    reportedBy: "Denunciado por",
    trending: "Em destaque",
    trendingReports: "Denúncias em destaque",
    noTrending: "Ainda não há denúncias em destaque",
    yourReports: "As tuas denúncias",
    noReportsYet: "Ainda não criaste denúncias",
    loadingAddress: "A carregar morada…",
    myLocation: "A minha localização",
    yourLocation: "A tua localização",
    mapView: "Vista de mapa",
    satelliteView: "Vista de satélite",
    changePhoto: "Alterar foto",
    uploadingPhoto: "A carregar...",
    photoUpdated: "Foto de perfil atualizada",
    photoUploadError: "Não foi possível carregar a foto",
    removePhoto: "Remover foto",
    inviteFriends: "Convidar amigos",
    achievements: "Conquistas",
    noAchievements: "Ainda não desbloqueaste conquistas",
    statusHistory: "Histórico de estado",
    seeTranslation: "Ver tradução",
    seeOriginal: "Ver original",
    translating: "A traduzir...",
    translationFailed: "Tradução indisponível",
    translatedAutomatically: "Traduzido automaticamente",
    deleteConfirm: "Queres eliminar esta denúncia?",
    loginToDeleteReports: "Inicia sessão para eliminar denúncias",
    onlyOwnReports: "Só podes eliminar as tuas denúncias",
  },
  auth: {
    backToMap: "Voltar ao mapa",
    subtitle: "Inicia sessão ou cria uma conta para reportar problemas na tua comunidade",
    login: "Iniciar sessão",
    register: "Registar",
    email: "Email",
    password: "Palavra-passe",
    username: "Nome de utilizador",
    orContinueWith: "Ou continua com",
    signInGoogle: "Iniciar sessão com Google",
    signUpGoogle: "Registar com Google",
    signingIn: "A iniciar sessão...",
    signIn: "Iniciar sessão",
    referralLabel: "Código de convite (opcional) 🎁",
    referralPlaceholder: "Insere um código de convite",
    referralBonus: "Vais receber 50 pontos bónus com este código! 🎁",
    creatingAccount: "A criar conta...",
    createAccount: "Criar conta",
    showPassword: "Mostrar senha",
    hidePassword: "Ocultar senha",
  },
  analytics: {
    otherCategory: "Outro",
    pageTitle: "Painel de Analytics",
    pageSubtitle: "Estatísticas públicas e transparência sobre os relatos da comunidade",
    backToMap: "Voltar ao mapa",
    noData: "Nenhum dado disponível",
    communityTitle: "Analytics da comunidade",
    communitySubtitle: "Estatísticas em tempo real dos relatos dos cidadãos",
    municipalityScopedSubtitle: "Estatísticas em tempo real dos relatos do seu município",
    totalReports: "Total de relatos",
    inProgress: "Em andamento",
    resolved: "Resolvidos",
    avgTime: "Tempo médio",
    categoryTitle: "Distribuição por categoria",
    categoryDesc: "Tipos de relatos recebidos",
    trendTitle: "Tendência dos últimos 7 dias",
    trendDesc: "Número de relatos diários",
    topAreasTitle: "Zonas mais relatadas",
    topAreasDesc: "As áreas com mais relatos ativos",
    adminTitle: "Analytics avançados (Admin)",
    adminSubtitle: "Métricas detalhadas visíveis apenas para administradores",
    dau: "Utilizadores ativos diários",
    wau: "Utilizadores ativos semanais",
    mau: "Utilizadores ativos mensais",
    avgSession: "Duração média da sessão",
    minutesShort: "min",
    mapInteractions: "Interações com o mapa",
    perSession: "Média por sessão",
    reportsPerUser: "Relatos por utilizador",
    average: "Média",
    completionRate: "Taxa de conclusão",
    loginToReport: "Login → Relato",
    funnelTitle: "Funil de conversão",
    funnelDesc: "Análise do percurso do utilizador (últimos 7 dias)",
    users: "Utilizadores",
    conversionPct: "% Conversão",
    devicesTitle: "Distribuição de dispositivos",
    devicesDesc: "Análise dos dispositivos utilizados",
  },
};
